/* eslint-disable */
import { useEffect } from 'react';
import { useNavigate, useRoutes, useLocation } from 'react-router-dom';
import Dashboard from '../Pages/dashboard/Dashboard';
import Login from '../Pages/login/Login';
import PropertyContextWrapper from '../Pages/property/PropertyContextWrapper';
import SelectTypeTransaction from '../Pages/property/SelectTypeTransaction';
import PropertyDetails from '../Pages/propertyDetails/PropertyDetails';
import SearchProperty from '../Pages/SearchProperty/SearchProperty';
import Settings from '../Pages/settings/Settings';
import { useUserStore } from '../store/user';
import http from '../api/axiosInstance';
import Filing from '../Pages/Filing/Filing';
import SelectTypeDemand from '../Pages/demand/SelectTypeDemand';
import DemandContextWrapper from '../Pages/demand/DemandContextWrapper';
import SearchDemand from '../Pages/SearchDemand/SearchDemand';
import DemandDetails from '../Pages/demandDetails/DemandDetails';
import EditPropertyContextWrapper from '../Pages/property/edit/EditPropertyContextWrapper';
import NewArea from '../Pages/area/NewArea';
import FinancialReport from '../Pages/financialReport/FinancialReport';
import EditDemandContextWrapper from '../Pages/demand/edit/EditDemandContextWrapper';
import AdaptDemand from '../Pages/AdaptDemand/AdaptDemand';
import { Calendar } from '../Pages/Calendar/Calendar';
import AdaptProperty from '../Pages/AdaptProperty/AdaptProperty';
import SelectUserToLogin from '../SelectUserToLogin/SelectUserToLogin';
import Cookies from 'js-cookie'


function AppRoutes() {
  const navigate = useNavigate();

  const accessToken = useUserStore((state) => state.accessToken)
  const setToken = useUserStore((state) => state.setToken)
  const setUserInfo = useUserStore((state) => state.setUserInfo)
  const setPropFacilities = useUserStore((state) => state.setPropFacilities)
  const userInfo = useUserStore((state) => state.userInfo)

  useEffect(() => {

    if (accessToken == "")
      Cookies.get('token') ? setToken(Cookies.get('token')) : null

    Cookies.get('agency') ? setUserInfo(JSON.parse(Cookies.get('agency'))) : null

    try {
      http({
        // url of the api endpoint (can be changed)
        url: "/global/facilities",
        method: "POST",
        // headers: {
        //   "Authorization" : "Bearer token"
        // }
      }).then((res) => {
        console.log("facilities", res);
        const tmp = {}
        res.data.result.Facilities.map(item => {
          tmp[item.Id] = item.DisplayText
        })

        console.log("tmp fac :", tmp)
        setPropFacilities(tmp)

      });
    } catch (e) {
      console.error(e);
    }

  }, [])

  const location = useLocation()

  

  useEffect(() => {
     
    if (!Cookies.get('token') && location.pathname != "/new-area") {
      navigate("/login");
    }
  }, [navigate]);

  const routes = useRoutes(
    [
      { path: '/submit-property/:type', element: <PropertyContextWrapper /> },
      { path: '/', element: <Dashboard /> },
      { path: '/submit-property', element: <SelectTypeTransaction /> },
      { path: '/login', element: <Login /> },
      { path: '/search-property', element: <SearchProperty /> },
      { path: '/property/adapt/:id/:row', element: <AdaptProperty /> },
      { path: '/property/:id', element: <PropertyDetails /> },
      { path: '/property_edit/:id', element: <EditPropertyContextWrapper /> },
      { path: '/demand_edit/:id', element: <EditDemandContextWrapper /> },
      { path: '/applicant/:id', element: <DemandDetails /> },
      { path: '/settings', element: <Settings /> },
      { path: '/filing', element: <Filing /> },
      { path: '/submit-demand', element: <SelectTypeDemand /> },
      { path: '/submit-demand/:type', element: <DemandContextWrapper /> },
      { path: '/applicant/adapt/:id/:row', element: <AdaptDemand /> },
      { path: '/search-demand', element: <SearchDemand /> },
      { path: '/new-area', element: <NewArea /> },
      { path: '/financial-report', element: <FinancialReport /> },
      { path: '/calendar', element: <Calendar /> },
      { path: '/select-user', element: <SelectUserToLogin /> },

    ]
  )
  return routes;
}

export default AppRoutes